import React, {useState, useEffect, useContext} from 'react';
import Header from '../../components/header';
import {useNavigate,useLocation} from "react-router-dom";
import axios from "axios";
import {baseURL} from "../../services/api";
import AuthContext from '../../components/shared/AuthContext';
import DataTable from "react-data-table-component";
import Swal from "sweetalert2";
import {useTranslation} from "react-i18next";
import OrgContext from "../../organisation/OrgContext";
import csvTemplate from "../../assets/templates/importClientTemplate.csv";
import ImportItems from "../../components/ImportItems";
import {DataGrid, GridToolbar} from '@mui/x-data-grid';
import { frFR, enUS } from '@mui/x-data-grid';
import {LinearProgress} from "@mui/material";
import moment from "moment";
import useAuthHelper from "../../helpers/AuthHelper";


const ClientFournisseur = (props) => {
    const [t, i18n] = useTranslation();
    const location = useLocation();
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [displayEdit, setDisplayEdit] = useState('none');
    const {user, logout} = useContext(AuthContext);
    const [clientId, setClientId] = useState();
    const [requestType,setRequestType] = useState(location.pathname);
    const { organisation, changeOrg } = useContext(OrgContext);
    const requiredCsvFileHeaders = [
        'nom',
        'prénom',
        'email',
        'téléphone',
        'nom de la société',
        'ice',
        'site web',
        'ADRESSE DE FACTURATION: pays',
        'ADRESSE DE FACTURATION: ville',
        'ADRESSE DE FACTURATION: addresse',
        'ADRESSE DE FACTURATION: code postal',
        'Utiliser addresse de facturation comme adresse de livraison',
        'ADRESSE DE LIVRAISON: pays',
        'ADRESSE DE LIVRAISON: ville',
        'ADRESSE DE LIVRAISON: addresse',
        'ADRESSE DE LIVRAISON: code postal\r'
    ];
    const columns = [
        { field: 'companyName', headerName: t("Nom du fournisseur"), flex: 1,
        },
        { field: 'email', headerName: t("Email"), flex: 1, },
        { field: 'phoneNumber', headerName: t(`Téléphone du fournisseur`), flex: 1, },
        { field: 'Créer le', headerName: t("Créer le"), flex: 1,
            renderCell: (params) => moment(params.row.created_at).format("DD/MM/YYYY")
        },
        {
            field: 'actions',
            headerName: t("ACTIONS"),
            width: 180,
            sortable: false,
            disableClickEventBubbling: true,
            
            renderCell: (params) => {
                const onDelete = (e) => {
                  const currentRow = params.row;
                  return deleteClient(currentRow.id);
                };

                const onEdit = (e) => {
                    const currentRow = params.row;

                    navigate("/fournisseurs/edit", {state: {client: currentRow}});
                  };

                const onDetails = (e) => {
                    const currentRow = params.row;

                    navigate("/client/details", {state: {client: currentRow}});
                };

                return (
                    <div className="btn-list">
                        <button onClick={onEdit} id="bEdit" type="button" className="btn  btn-sm btn-primary">
                            <span className="fe fe-edit" title={'Modifier'}> </span>
                        </button>
                        <button onClick={onDelete} id="bDel" type="button" className="btn  btn-sm btn-danger">
                            <span className="fe fe-trash-2" title={'Supprimer'}> </span>
                        </button>
                        <button onClick={onDetails} id="bDetails" type="button" className="btn btn-sm btn-primary">
                            <span className="fe fe-eye" title={'Voir les détails'}> </span>
                        </button>
                    </div>
                );
            },
        }
    ];
    const [clients, setClients] = useState([]);
    const [loadingData, setLoadingData] = useState(false);

    const getClients = async () => {
        setLoading(true)
        setLoadingData(true);
        axios.get(baseURL + `/client/getbyuser/${user.id}/fournisseurs/${organisation.id}`)
            .then((response) => {
                setClients(response.data.data)
                setLoading(false);
                setLoadingData(false);
            })
            .catch((error) => {
                setLoadingData(false);
                console.log("error while retrieving products by user" + error)
            })
    }
    const {onlyCommercial} =useAuthHelper();

    useEffect(() => {
        onlyCommercial();

        console.log("requestType "+requestType);
        getClients();
    }, [])
    const deleteClient = async (productId) => {
        const response = await axios.delete(baseURL + `/client/delete/${productId}/fournisseurs/${user.id}/${organisation.id}`)
            .then((response) => {
                setClients(response.data.data)
                setLoading(false)
                Swal.fire(
                    t('Le client a été supprimer avec succès'),
                    t(''),
                    'success'
                );
            })
            .catch((error) => console.log("error while retrieving products by user" + error))
    };
    const handleSelectRow = ({selectedRows}) => {
        if (selectedRows.length === 0) {
            setDisplayEdit('none');
        } else {
            setDisplayEdit('block');
            setClientId(selectedRows[0].id);
            console.log('Selected Rows: ', selectedRows);
        }
    };
    return (
        <>
            <div className="main-container container-fluid">

                <div className="row">
                    <div className="col-md-12 col-lg-12">
                        <div className="card">
                            <div className="card-header">
                                <h3 className="card-title" style={ {width:"100%"} }>Liste des {props.clientType}</h3>
                                <div className="actionCardContainer">
                                    <button type="button" onClick={() => navigate(`/${props.clientType}/add`)}
                                            className="floatRightBtn btn btn-icon  btn-primary me-2 bradius"><i
                                        className="fe fe-plus"></i></button>
                                    {/* <ImportItems
                                        template={csvTemplate}
                                        requiredCsvHeaders={requiredCsvFileHeaders}
                                        apiSaveUrl={'/client/save'}
                                        id={'fournisseur'}
                                    /> */}
                                    {/*<button style={{display: displayEdit}} type="button"*/}

                                    {/*        className="floatRightBtn btn btn-icon  btn-primary me-2 bradius"><i*/}
                                    {/*    className="fe fe-edit"></i></button>*/}
                                    <button style={{display: displayEdit}} type="button"
                                            onClick={() => deleteClient(clientId)}
                                            className="floatRightBtn btn btn-icon  btn-primary me-2 bradius"><i
                                        className="fe fe-trash"></i></button>
                                </div>
                            </div>
                            <div className="card-body">
                            <div style={{margin: "20px", height: 600, width: "100%" }}>
                                    <DataGrid
                                        rows={clients}
                                        columns={columns}

                                        pagination={false}
                                        checkboxSelection
                                        localeText={
                                            i18n.language == "fr" ?
                                                frFR.components.MuiDataGrid.defaultProps.localeText :
                                                enUS.components.MuiDataGrid.defaultProps.localeText
                                        }
                                        slotProps={{
                                            toolbar: {
                                                printOptions: { disableToolbarButton: true },
                                                csvOptions: { disableToolbarButton: true },
                                            }}
                                        }
                                        slots={{
                                            loadingOverlay: LinearProgress,
                                            toolbar: GridToolbar
                                        }}
                                        loading={loadingData}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default ClientFournisseur;